import { Injectable, Inject } from '@angular/core';
import { HubConnection, LogLevel, HubConnectionBuilder } from '@microsoft/signalr';
import { KigSettings, KIG_SETTINGS } from 'settings/kig-settings';

@Injectable({
  providedIn: 'root'
})
export class HubConnectionFactory {

  private apiUrl: string;

  constructor(@Inject(KIG_SETTINGS) private settings: KigSettings) {
    this.apiUrl = this.settings.apiUrl;
  }

  public create(hubName: string): HubConnection {
    return new HubConnectionBuilder()
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Warning)
      .withUrl(`${this.apiUrl}${hubName}`)
      .build();
  }
}
